
namespace TabAurous.ECommerce {

    @Serenity.Decorators.registerClass()
    export class ECommSalesLaborGrid extends Serenity.EntityGrid<ECommSalesLaborRow, any> {
        protected getColumnsKey() { return 'ECommerce.ECommSalesLabor'; }
        protected getIdProperty() { return ECommSalesLaborRow.idProperty; }
        protected getInsertPermission() { return ECommSalesLaborRow.insertPermission; }
        protected getLocalTextPrefix() { return ECommSalesLaborRow.localTextPrefix; }
        protected getService() { return ECommSalesLaborService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}